<template>
  <li v-if="elementExists && text" class="nav-link" :data-active="active" ><a :href="href" v-smooth-scroll >{{ text }}</a></li>
</template>

<script>
export default {
  name: "NavLink",
  props: {
    href: String,
    observe: Array,
    text: String,
  },
  data() {
    return {
      elementExists: false,
      active: false,
      observer: null,
      visibility: {},
    }
  },
  mounted() {
    if (this.observe && "IntersectionObserver" in window) {
      // Make link active if the "observe" element is in view.
      // Be aware this will give funky results if you attempt to observe elements which
      // are side by side, rather than stacked.

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visibility[entry.target.id] = entry.isIntersecting
          })
          this.setActive()
        },
        // Threshhold at 0 sometimes needs a tiny scroll to make active.
        // Threshhold at 1 sometimes makes 2 sections active.
        // May require tweaking.
        {threshold: 0.5}
      )
      this.observer = observer;

      this.observe.forEach((id) => {
        const toObserve = document.querySelector(`#${id}`);

        if (toObserve) {
          this.elementExists = true
          this.visibility[id] = false
          observer.observe(toObserve);
        }
      })
    }
  },
  methods: {
    setActive () {
      let active = false
      for (const i in this.observe) {
        const id = this.observe[i]
        if (this.visibility[id]) {
          active = true
        }
      }
      this.active = active
    }
  },
}

</script>

<style lang="scss" scoped>
  .nav-link {
      margin-right: 2em;
      font-size: 13px;

      &:last-child {
        margin-right: 0;
      }

      &[data-active="true"] {
        a {
          font-weight: bold;
        }
      }

      &[data-active="true"] +  &[data-active="true"] {
        // In some situations, more than one area might be "active". So make sure to
        // only bold the first one
        a {
          font-weight: normal;
        }
      }


      a {
        text-decoration: none;
        text-transform: uppercase;
        color: #000;
      }
    }

    [dir="rtl"] .nav-link {
      margin-left: 2em;
      margin-right: 0;
    }

</style>
